import {
  BodyScrollOptions,
  clearAllBodyScrollLocks,
  disableBodyScroll,
  enableBodyScroll,
} from 'body-scroll-lock';
import { useEffect, useRef } from 'react';

const allowTouchMove: BodyScrollOptions['allowTouchMove'] = (el) => {
  let element: HTMLElement | Element | null = el;
  while (element && element !== document.body) {
    if (element.classList.contains('body-scroll-lock-ignore')) return true;
    element = element.parentElement;
  }
  return false;
};

export const useBodyScrollLock = (
  locked: boolean,
  elementOrSelector: HTMLElement | string = document.documentElement,
  options?: BodyScrollOptions
) => {
  const optionsRef = useRef(options);
  const el =
    typeof elementOrSelector === 'string'
      ? document.querySelector(elementOrSelector)
      : elementOrSelector;
  optionsRef.current = options;

  useEffect(() => {
    if (!el) return;

    if (locked) {
      disableBodyScroll(el, {
        allowTouchMove,
        ...optionsRef.current,
      });
    } else {
      enableBodyScroll(el);
    }
    return clearAllBodyScrollLocks;
  }, [el, locked]);
};
